import { __extends } from "tslib";
import { getLightElement } from '@tyler-components-web/core';
import { BaseAdapter } from '../../core/adapters/base-adapter';
import { MENU_CONSTANTS } from '../../menu';
var OmnibarHelpButtonAdapter = /** @class */ (function (_super) {
    __extends(OmnibarHelpButtonAdapter, _super);
    function OmnibarHelpButtonAdapter(component) {
        return _super.call(this, component) || this;
    }
    OmnibarHelpButtonAdapter.prototype.initialize = function () {
        this._menuElement = getLightElement(this._component, MENU_CONSTANTS.elementName);
    };
    OmnibarHelpButtonAdapter.prototype.setMenuOptions = function (options) {
        this._menuElement.options = options;
    };
    return OmnibarHelpButtonAdapter;
}(BaseAdapter));
export { OmnibarHelpButtonAdapter };
